import LicenseProto from "./license-proto";
import {License} from "../const/license";

export default class LicenseEnterprise2023 extends LicenseProto {

    constructor(licenseUsers:number) {
        super(License.ENTERPRISE);

        this.maxUsers   = 5000

        this.isPro      = true
        this.isBusiness = true

        this.billingAndFinance  = true;
        this.maxStorage         = 'Unlimited';
        this.name               = 'Enterprise';

        this.isPaid = true;

        this.licenseUsers = (licenseUsers)?licenseUsers:false;
    }


}
